import React, { Component } from 'react';
import PropTypes from 'prop-types';

import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import RestoreIcon from 'material-ui/svg-icons/action/settings-backup-restore';
import Popover from 'material-ui/Popover';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';

const styles = {
  textFieldStyle: {
    paddingLeft: '20px'
  },
  menuItemStyle: {
    fontSize: '15px',
    minHeight: '32px',
    lineHeight: '32px'
  }
};

class ColumnChooser extends Component {
  constructor(props) {
    super(props);

    // Scan and filter out columns that don't exist in this env
    // fix due to 1.5.0 -> 1.6.0 data changes
    let columnReset = false;
    const selectedColumns = this.props.selectedColumns.filter(col => {
      if (col) {
        return true;
      }

      columnReset = true;
      return false;
    });

    this.state = {
      open: false,
      filterText: '',
      columnReset,
      selectedColumns
    };
  }

  componentDidMount() {
    // if user is coming in with bad columns then reset their prefs
    if (this.state.columnReset) {
      this.props.resetColumns();
      this.setState({ columnReset: false });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // update local state with column changes
    if (this.props.selectedColumns !== prevProps.selectedColumns) {
      const selectedColumns = this.props.selectedColumns.filter(col => {
        if (col) {
          return true;
        }
        return false;
      });
      this.setState({ selectedColumns });
    }
  }

  handlePopoverRequestOpen = event => {
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget
    });
  };

  handlePopoverRequestClose = () => {
    this.setState({
      open: false
    });
  };

  sortColumnKeys(columns = {}, selectedColumnNames) {
    const columnKeys = Object.keys(columns);
    const sortedColumnKeys = [...columnKeys];

    sortedColumnKeys.sort((columnKeyA, columnKeyB) => {
      // alpha sort by column alias,
      // but place all selected columns at the top
      const nameA = columns[columnKeyA].name;
      const aliasA = columns[columnKeyA].alias;
      const nameB = columns[columnKeyB].name;
      const aliasB = columns[columnKeyB].alias;

      if (
        !selectedColumnNames.includes(nameA) &&
        !selectedColumnNames.includes(nameB)
      ) {
        // neither a nor b are selected
        return this.alphaSort(aliasA, aliasB);
      }

      // one or both of a and b are selected
      if (
        selectedColumnNames.includes(nameA) &&
        selectedColumnNames.includes(nameB)
      ) {
        // both a and b are selected
        return this.alphaSort(aliasA, aliasB);
      } else if (
        selectedColumnNames.includes(nameA) &&
        !selectedColumnNames.includes(nameB)
      ) {
        // only a is selected
        return -1;
      } else {
        // only b is selected
        return 1;
      }
    });

    return sortedColumnKeys;
  }

  handleTextFieldChange = (event, value) => {
    this.setState({ filterText: value });
  };

  handleMenuChange = (event, value) => {
    const selectedColumnNames = this.state.selectedColumns.map(
      selectedColumnInfo => selectedColumnInfo.name
    );
    if (selectedColumnNames.length > value.length) {
      // if the new IconMenu multiple value array is SHORTER than
      // than the original array of selectedColumnNames

      // get an array of columns to remove
      const changedColumns = this.difference(selectedColumnNames, value);

      // and communicate intent to remove a column
      this.props.removeColumn(changedColumns[0]);
    } else {
      // if the new IconMenu multiple value array is LONGER than
      // than the original array of selectedColumnNames

      // get an array of columns to add
      const changedColumns = this.difference(value, selectedColumnNames);

      // and communicate intent to add a column
      this.props.addColumn(changedColumns[0]);
    }

    // TODO: implement column reordering
    //  this.props.reorderColumn('columnName', indexPositionInteger)
  };

  alphaSort(a, b) {
    // alpha sort by string
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  }

  difference(a = [], b = []) {
    const s = new Set(b);
    return a.filter(x => !s.has(x));
  }

  fuzzyMatch(source, input) {
    return source.toUpperCase().includes(input.toUpperCase());
  }

  getMenuItems(columns, selectedColumnNames, filterText) {
    return this.sortColumnKeys(columns, selectedColumnNames)
      .filter(columnKey => this.fuzzyMatch(columnKey, filterText))
      .map(columnKey => {
        const name = columns[columnKey].name;
        const alias = columns[columnKey].alias;
        return (
          <MenuItem
            style={styles.menuItemStyle}
            key={name}
            insetChildren={true}
            checked={selectedColumnNames.includes(name)}
            value={name}
            primaryText={alias}
          />
        );
      });
  }

  render() {
    const { open, anchorEl, filterText, selectedColumns } = this.state;
    const { columns, resetColumns } = this.props;
    const selectedColumnNames = selectedColumns.map(
      selectedColumnInfo => selectedColumnInfo.name
    );

    return (
      <div>
        <IconButton
          tooltip="Choose columns"
          tooltipPosition="bottom-left"
          onClick={this.handlePopoverRequestOpen}
        >
          <MoreVertIcon />
        </IconButton>

        <Popover
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{ horizontal: 'middle', vertical: 'center' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
          onRequestClose={this.handlePopoverRequestClose}
        >
          <Paper>
            <TextField
              value={filterText}
              style={styles.textFieldStyle}
              hintText="Type to filter column choices"
              onChange={this.handleTextFieldChange}
            />
            <IconButton
              tooltip="Reset to default"
              tooltipPosition="bottom-left"
              onClick={() => {
                resetColumns();
              }}
              style={{ float: 'right' }}
            >
              <RestoreIcon />
            </IconButton>
          </Paper>

          <Menu
            maxHeight={256}
            value={selectedColumnNames}
            multiple={true}
            onChange={this.handleMenuChange}
            disableAutoFocus
            desktop
          >
            {this.getMenuItems(columns, selectedColumnNames, filterText)}
          </Menu>
        </Popover>
      </div>
    );
  }
}

export default ColumnChooser;

ColumnChooser.propTypes = {
  columns: PropTypes.object,
  selectedColumns: PropTypes.arrayOf(PropTypes.object),
  addColumn: PropTypes.func,
  removeColumn: PropTypes.func,
  reorderColumn: PropTypes.func,
  resetColumns: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/common/DataGrid/ColumnChooser.js